export default {
  allSeverityLevels: 'Všetky úrovne závažnosti',
  zeroSeverityLevels: 'Je vybraných 0 úrovní závažnosti',
  severityLevels: 'Úrovne závažnosti',
};
